export default __webpack_public_path__ + "public/images/home/presets/small-flat@3x.png?b658f30a";